import React, { useEffect, useState } from "react";
import { makePost } from "@culturehq/client";
import { BooleanField, Form, Loader, SubmitButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";

const SOCIAL_NETWORKS = {
  Facebook: t("Meta"),
  Linkedin: t("LinkedIn"),
  TikTok: t("Tiktok")
};

const SocialIntegrations = () => {
  const { profile, fetchedProfile } = useProfile();
  const [loading, setLoading] = useState(false);
  const [socialMediaTypes, setSocialMediaTypes] = useState(
    profile.organization.socialMediaTypes.reduce((obj, socialMediaType) => (
      { ...obj, [socialMediaType.name]: true }
    ), {})
  );

  useEffect(
    () => {
      setSocialMediaTypes(
        profile.organization.socialMediaTypes.reduce((obj, socialMediaType) => (
          { ...obj, [socialMediaType.name]: true }
        ), {})
      );
    },
    [profile]
  );

  const handleSubmit = async options => {
    setLoading(true);
    const values = Object.keys(options).filter(key => !!options[key]);
    const { organization } = await makePost("/organizations/social_media_type", { socialMedia: values });
    fetchedProfile({ ...profile, organization });
    setLoading(false);
  };

  return (
    <>
      <PageHeader title={t("Social Integrations")}>
        <Trans>
          Here you can configure which Social Networks are you going to allow in
          your organization. Your selections are going to be available for social
          shares in the approval stories section.
        </Trans>
      </PageHeader>
      <Loader loading={loading}>
        <Form
          initialValues={socialMediaTypes}
          onSubmit={handleSubmit}
        >
          {Object.keys(SOCIAL_NETWORKS).map(key => (
            <BooleanField key={key} name={key}>
              {SOCIAL_NETWORKS[key]}
            </BooleanField>
          ))}
          <SubmitButton primary>
            {submitting => (
              submitting ? <Trans>Submitting...</Trans> : <Trans>Save Changes</Trans>
            )}
          </SubmitButton>
        </Form>
      </Loader>
    </>
  );
};

export default SocialIntegrations;
